import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d362f3e6&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=d362f3e6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d362f3e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d362f3e6')) {
      api.createRecord('d362f3e6', component.options)
    } else {
      api.reload('d362f3e6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=d362f3e6&scoped=true", function () {
      api.rerender('d362f3e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/research/add-tag/index.vue"
export default component.exports